/* eslint-disable consistent-return */
import {
  ApolloClient,
  ApolloProvider,
  createHttpLink,
  from,
  InMemoryCache,
} from '@apollo/client';
import {onError} from '@apollo/client/link/error';
import {setContext} from '@apollo/client/link/context';
import {CssBaseline} from '@material-ui/core';
import ThemeProvider from '@material-ui/styles/ThemeProvider';
import theme from 'packages/styles/theme';
import RootRouter from 'packages/router/RootRouter';
import {API_URL} from 'packages/constants/constants';
import {useContext} from 'react';
import {AuthContext} from 'packages/context/AuthContext';

const createApolloClient = (token: string) => {
  const httpLink = createHttpLink({
    uri: API_URL,
  });

  const errorLink = onError(
    ({graphQLErrors, networkError, operation, forward}) => {
      if (graphQLErrors) {
        let oldHeaders;
        graphQLErrors.forEach((error) => {
          switch (error.extensions.code) {
            // Apollo Server sets code to UNAUTHENTICATED
            // when an AuthenticationError is thrown in a resolver
            case 'UNAUTHENTICATED':
              // Modify the operation context with a new token
              oldHeaders = operation.getContext().headers;
              operation.setContext({
                headers: {
                  ...oldHeaders,
                  authorization: token,
                },
              });
              return forward(operation);
            default:
              console.log(
                `[GraphQL error]: Message: ${
                  error.message
                }, Location: ${error.locations.map(
                  (location) => `${location.column}, ${location.line}`
                )}, Path: ${error.path}`
              );
              break;
          }
        });
      }

      // To retry on network errors, we recommend the RetryLink
      // instead of the onError link. This just logs the error.
      if (networkError) {
        console.error(
          '🚀 ~ file: App.tsx ~ line 58 ~ createApolloClient ~ networkError',
          networkError
        );
      }
    }
  );

  const authLink = setContext((_, {headers}) => {
    return {
      headers: {
        ...headers,
        authorization: token ? `${token}` : '',
      },
    };
  });

  return new ApolloClient({
    cache: new InMemoryCache(),
    link: from([authLink, errorLink, httpLink]),
  });
};

function App() {
  const {idToken} = useContext(AuthContext);
  const client = createApolloClient(idToken);
  return (
    <ApolloProvider client={client}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <RootRouter />
      </ThemeProvider>
    </ApolloProvider>
  );
}

export default App;
